class CartTool extends HTMLElement {
    constructor() {
        super();

        const buttons = this.querySelectorAll('.cartTool-item');

        buttons.forEach((button) => {
            button.addEventListener('click', (event) => {
                const target =
                    event.target.closest('[data-popup]') ||
                    event.currentTarget;

                const id = target?.dataset?.popup;

                if (!id) return;

                const popup = document.getElementById(id);
                const previewCart =
                    document.querySelector('.previewCart');

                popup?.classList.add('show');
                previewCart?.classList.add('active-tool');
            });
        });
    }
}

if (!customElements.get('cart-item-tool')) {
    customElements.define('cart-item-tool', CartTool);
}

class CartCancel extends HTMLElement {
    constructor() {
        super();

        const button = this.querySelector('button');

        button?.addEventListener('click', () => {
            document
                .querySelector('.popup-toolDown.show')
                ?.classList.remove('show');

            document
                .querySelector('.previewCart')
                ?.classList.remove('active-tool');
        });
    }
}

if (!customElements.get('cart-cancel-popup')) {
    customElements.define(
        'cart-cancel-popup',
        CartCancel
    );
}

class CartNote extends HTMLElement {
    constructor() {
        super();

        const updateButton =
            this.querySelector('[data-update-note]');

        updateButton?.addEventListener(
            'click',
            this.updateCartNote.bind(this)
        );
    }

    async updateCartNote(event) {
        event.preventDefault();

        const note =
            this.querySelector('.text-area')?.value || '';

        try {
            const body = JSON.stringify({
                note
            });

            await fetch(
                window.routes?.cart_update_url ||
                    '/cart/update.js',
                {
                    ...fetchConfig(),
                    body
                }
            );
        } catch (error) {
            console.error(
                'Unable to update cart note:',
                error
            );
        }

        document
            .querySelector('.popup-toolDown.show')
            ?.classList.remove('show');

        document
            .querySelector('.previewCart')
            ?.classList.remove('active-tool');
    }
}

if (!customElements.get('cart-note')) {
    customElements.define('cart-note', CartNote);
}

class CouponCode extends HTMLElement {
    constructor() {
        super();

        this.input =
            this.querySelector(
                'input[name="discount"]'
            );

        this.updateButton =
            this.querySelector(
                '[data-update-coupon]'
            );

        this.initializeCouponField();

        this.updateButton?.addEventListener(
            'click',
            this.applyCoupon.bind(this)
        );

        window.addEventListener(
            'bestypop:store-ready',
            this.initializeCouponField.bind(this)
        );
    }

    getActivePartnerCode() {
        if (
            !window.BestyPopStore ||
            typeof window.BestyPopStore
                .getCurrentStoreCode !== 'function'
        ) {
            return '';
        }

        try {
            return (
                window.BestyPopStore
                    .getCurrentStoreCode() || ''
            );
        } catch (error) {
            console.warn(
                'Unable to read active partner code:',
                error
            );

            return '';
        }
    }

    cleanCode(value) {
        if (!value) return '';

        const code =
            String(value).trim();

        if (
            !/^[A-Za-z0-9_-]{3,60}$/.test(code)
        ) {
            return '';
        }

        return code;
    }

    initializeCouponField() {
        if (!this.input) return;

        const partnerCode =
            this.cleanCode(
                this.getActivePartnerCode()
            );

        if (partnerCode) {
            /*
             * A partner storefront is active.
             * Remove stale manually saved coupons such as CJP.
             */
            try {
                localStorage.removeItem(
                    'storedDiscount'
                );
            } catch (error) {
                // Ignore localStorage access errors.
            }

            this.input.value =
                partnerCode;

            this.input.setAttribute(
                'data-partner-code',
                partnerCode
            );

            this.input.setAttribute(
                'readonly',
                'readonly'
            );

            return;
        }

        this.input.removeAttribute(
            'data-partner-code'
        );

        this.input.removeAttribute(
            'readonly'
        );

        let storedDiscount = '';

        try {
            storedDiscount =
                localStorage.getItem(
                    'storedDiscount'
                ) || '';
        } catch (error) {
            storedDiscount = '';
        }

        this.input.value =
            this.cleanCode(storedDiscount);
    }

    async applyDiscountCode(code) {
        const cleanCode =
            this.cleanCode(code);

        if (!cleanCode) {
            return false;
        }

        try {
            const response = await fetch(
                `/discount/${encodeURIComponent(
                    cleanCode
                )}`,
                {
                    method: 'GET',
                    credentials: 'same-origin',
                    cache: 'no-store'
                }
            );

            return response.ok;
        } catch (error) {
            console.error(
                'Unable to apply discount:',
                error
            );

            return false;
        }
    }

    async applyCoupon(event) {
        event.preventDefault();

        const activePartnerCode =
            this.cleanCode(
                this.getActivePartnerCode()
            );

        /*
         * Partner code always wins.
         * Manual coupons cannot replace an active storefront code.
         */
        if (activePartnerCode) {
            if (this.input) {
                this.input.value =
                    activePartnerCode;
            }

            try {
                localStorage.removeItem(
                    'storedDiscount'
                );
            } catch (error) {
                // Ignore localStorage access errors.
            }

            await this.applyDiscountCode(
                activePartnerCode
            );
        } else {
            const enteredCode =
                this.cleanCode(
                    this.input?.value
                );

            if (!enteredCode) {
                return;
            }

            try {
                localStorage.setItem(
                    'storedDiscount',
                    enteredCode
                );
            } catch (error) {
                // Discount can still be applied if storage fails.
            }

            await this.applyDiscountCode(
                enteredCode
            );
        }

        document
            .querySelector('.popup-toolDown.show')
            ?.classList.remove('show');

        document
            .querySelector('.previewCart')
            ?.classList.remove('active-tool');

        if (
            window.Shopify &&
            typeof Shopify.getCart === 'function'
        ) {
            Shopify.getCart((cart) => {
                window.sharedFunctions
                    ?.updateSidebarCart(cart);
            });
        }
    }
}

if (!customElements.get('coupon-code')) {
    customElements.define(
        'coupon-code',
        CouponCode
    );
}